import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();

  const storedUser = localStorage.getItem("user");
  const isLoggedIn = !!storedUser;

  const [showCookie, setShowCookie] = useState(false);

  /* ================= COOKIE CHECK ================= */
  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setShowCookie(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShowCookie(false);
  };

  /* ================= NAVIGATION ================= */

  const goHome = () =>
    navigate(isLoggedIn ? "/user/home" : "/");

  const goVideos = () =>
    navigate(isLoggedIn ? "/user/videos-feed" : "/videos");

  const goShorts = () =>
    navigate(isLoggedIn ? "/user/shorts-feed" : "/shorts");

  const goSongs = () =>
    navigate(isLoggedIn ? "/user/songs" : "/songs");

  const goPost = () =>
    navigate(isLoggedIn ? "/user/posts-feed" : "/post");

  const goLogin = () =>
    navigate(isLoggedIn ? "/user/dashboard" : "/login");

  const goRegister = () =>
    navigate(isLoggedIn ? "/user/dashboard" : "/register");

  /* ================= ACTIVE STYLE ================= */

  const isActive = (path) => location.pathname === path;

  const linkStyle = (path) => ({
    cursor: "pointer",
    whiteSpace: "nowrap",
    color: isActive(path) ? "#ff2d55" : "#333",
    fontWeight: isActive(path) ? "600" : "500",
    transition: "0.2s ease",
  });

  return (
    <>
      {/* ================= HEADER ================= */}
      <header style={styles.header}>
        <div style={styles.logo} onClick={goHome}>
          <img src="/logo192.png" alt="ShareVideo" height="28" />
          <span style={{ marginLeft: 8 }}>ShareVideo</span>
        </div>

        <nav style={styles.nav}>
          <span
            onClick={goHome}
            style={linkStyle(isLoggedIn ? "/user/home" : "/")}
          >
            Home
          </span>

          <span
            onClick={goVideos}
            style={linkStyle(isLoggedIn ? "/user/videos-feed" : "/videos")}
          >
            Videos
          </span>

          <span
            onClick={goShorts}
            style={linkStyle(isLoggedIn ? "/user/shorts-feed" : "/shorts")}
          >
            Shorts
          </span>

          {/* ===== SONGS ADDED ===== */}
          <span
            onClick={goSongs}
            style={linkStyle(isLoggedIn ? "/user/songs" : "/songs")}
          >
            Songs
          </span>

          <span onClick={goPost} style={styles.postBtn}>
            + Post
          </span>

          {!isLoggedIn && (
            <>
              <span onClick={goLogin} style={linkStyle("/login")}>
                Login
              </span>

              <span onClick={goRegister} style={linkStyle("/register")}>
                Register
              </span>
            </>
          )}
        </nav>
      </header>

      {/* ================= PAGE CONTENT ================= */}
      <div style={styles.pageWrapper}>
        <Outlet />
      </div>

      {/* ================= COOKIE BANNER ================= */}
      {showCookie && (
        <div style={styles.cookieBanner}>
          <div style={styles.cookieContent}>
            <p style={styles.cookieText}>
              We use cookies to improve your experience and serve personalized
              ads via Google AdSense. By continuing to use this site, you agree
              to our Privacy Policy.
            </p>
            <button onClick={acceptCookies} style={styles.cookieButton}>
              Accept
            </button>
          </div>
        </div>
      )}
    </>
  );
}

/* ================= STYLES ================= */

const styles = {
  header: {
    minHeight: 60,
    padding: "10px 16px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #eee",
    background: "#fff",
    width: "100%",
    boxSizing: "border-box",
  },

  logo: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: 18,
    cursor: "pointer",
  },

  nav: {
    display: "flex",
    flexWrap: "wrap",
    gap: 18,
    alignItems: "center",
    marginTop: 6,
  },

  postBtn: {
    padding: "6px 14px",
    borderRadius: 20,
    background: "#ff2d55",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },

  pageWrapper: {
    width: "100%",
    overflowX: "hidden",
  },

  cookieBanner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#111",
    color: "#fff",
    padding: "15px",
    zIndex: 9999,
  },

  cookieContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },

  cookieText: {
    margin: 0,
    flex: "1 1 300px",
  },

  cookieButton: {
    background: "#ff9800",
    color: "#000",
    border: "none",
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: "bold",
    borderRadius: "4px",
    whiteSpace: "nowrap",
  },
};